var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_c('span',[_c('i',{staticClass:"fa fa-tag",style:({ color: _vm.color }),attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.label.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }